module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/assets/md/empty.md
// module id = I12p
// module chunks = 1